import * as Utils from '../../commons/utils/Utils';
import React, { useEffect, useState, useRef } from 'react';
import { FormattedMessage} from "react-intl";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from '@material-ui/core/TextField';
import { Input } from '@material-ui/core'
const TicketPresupuestoEditModal = (props) => {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({cantidad: 0, costo: 0});

	useEffect(() => {
		init();
	}, []);

	const init = () => {
		let copy = JSON.parse(JSON.stringify(data));
		switch (props.type) {
			case "presupuestoTarea":
				copy.costo = props.element.precio;
				break;
			case "servicioItem":
				copy.costo = props.element.costo;
				copy.cantidad = props.element.cantidad;
				break;
			default:
				console.log('default');
		}
		setData(copy);
	};

	const handleMaterialChange = (name, value) => {
		let copy = JSON.parse(JSON.stringify(data));
		if ((value && value >= 0) || !value) {
			copy[name] = value;
		}
		setData(copy);
	}

	return (
		<>
			<div>
				<div className="text-center mt-2">
					<h3>
						<FormattedMessage id="Repuesto" defaultMessage="Repuesto" /> : 
						{props.element.external_code ? (props.element.external_code + ' - ') : ''}
						{props.element.descripcion ? (props.element.descripcion + ' - ') : ''}
						{props.element.cuenta_mayor_descripcion ? props.element.cuenta_mayor_descripcion : ''}
					</h3>
				</div>
				<div className="table-responsive" style={{padding: "15px"}}>
					<table
						id="dataTable"
						className="dataTable table nowrap server-side table-hover dataTableMovil"
						width="100%"
					>
						<thead>
							<tr>
								{
									props.type === "servicioItem" ? 
										<th scope="col">
											<FormattedMessage id="Cantidad" defaultMessage="Cantidad" />
										</th>
									: ''
								}
								<th scope="col">
									<FormattedMessage id="Precio" defaultMessage="Precio" />
								</th>
							</tr>
						</thead>
						<tbody>
							<tr key={props.element.id}>
								{
									props.type === "servicioItem" ?
										<td className="all custom-lineHeight">
											<TextField
												id="number"
												type="number"
												onChange={e => handleMaterialChange('cantidad', e.target.value)}
												InputProps={{
													inputProps: { 
														min: 0 
													}
												}}
												variant="standard"
												value={data.cantidad}
												w
											/>
										</td>
									: ''
								}
								<td className="all custom-lineHeight">
									<TextField
										id="standard"
										type="number"
										onChange={e => handleMaterialChange('costo', e.target.value)}
										InputProps={{
											inputProps: { 
												min: 0 
											}
										}}
										variant="standard"
										value={data.costo}
										fullWidth
									/>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div className="text-center d-flex justify-content-center">
					<button type="button" className="btn btn-primary mr-1" onClick={(e) => props.updateElement(data)}>
						<i className="fa fa-check-circle"></i><FormattedMessage id="marcasAbm.finish_button.guardar" defaultMessage=" Guardar"/>
					</button>
					<button type="button" className="btn btn-danger" onClick={(e) => props.closeModalEdit()}>
						<i className="fa fa-times-circle"></i> { props.intl.formatMessage({ id: 'Cancelar', defaultMessage: 'Cancelar' })}
					</button>
				</div>
			</div>
		</>
	);
};

export default TicketPresupuestoEditModal;
